<ng-container *transloco="let convert;">
  @if (photoList?.length) {
    <div class="vehicle-img-sec container p-0 ms-0">
      <div class="row">
        @for (imgItem of photoList; track imgItem; let i = $index; let isFirst = $first) {
          <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <div class="vehicle-img-card container mt-4 rounded p-3 ms-0" [ngClass]="{'selected-photos-card': imgItem.isSelected}">
              @if (isFirst && showMainImgTag) {
                <div class="photos-main-img bg-brand rounded-top text-center w-100">{{convert('sellModule.posting.photoCard.textMainImage')}}</div>
              }
              <div class="row">
                @if (!imgItem.showSpinner) {
                  <div class="col-md-12">
                    <div class="vehicle-img-card-header pb-2 d-flex">
                      <div class="control-wrapper col-md-3 ps-0 pe-0">
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input excludes__input"
                            id="image-{{flowName}}-{{i}}"
                            aria-label="image-{{flowName}}-{{i}}"
                            data-track-name="image-{{flowName}}-{{i}}"
                            data-track-elem="check box"
                            data-track-trigger="filter"
                            [checked]="imgItem.isSelected"
                            (change)="onPhotosCardCheckboxChange($event, imgItem)"/>
                          <label class="custom-control-label excludes__label" for="image-{{flowName}}-{{i}}"></label>
                        </div>
                      </div>
                    </div>
                    <div class="vehicle-img-card-body">
                      <div class="img-container d-flex justify-content-center align-items-center">
                        <img class="mx-auto d-block" [src]="imgItem.url || imgItem.sourceUrl" alt="image-{{i}}">
                      </div>
                      @if (locationOptList?.length) {
                        <div class="form-group location-list mb-0 mt-2">
                          <label for="location-{{i}}">{{convert('sellModule.posting.photoCard.labelLocation')}}</label>
                          <div class="select-wrapper">
                            <select id="location-{{i}}" class="custom-select wrapText" (change)="setPhotoLocationOpt(i, $event.target.value)">
                              <option [value]="''">{{convert('sellModule.posting.photoCard.textUnassigned')}}</option>
                              @for (opt of locationOptList; track opt) {
                                <option
                                  [selected]="opt.code === imgItem.location"
                                  [value]="opt.code">
                                  {{opt.description}}
                                </option>
                              }
                            </select>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (imgItem.showSpinner) {
                  <div class="col-md-12 spinner-container">
                    <app-spinner></app-spinner>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (selectedCardCount) {
    <app-action-bar
      [actionBarButtonConfigList]="actionBarConfigArr"
      (actionBarBtnAction)="updatesFromActionBar($event)"
    ></app-action-bar>
  }

  <trap-focus [enableFocusTrap]="true" [enableArrowKeys]="true">
    <app-modal [modalId]="'photosModal'">
      <div class="modal-close-container">
        <button
          id="pf_close_x_button"
          class="modal__close"
          [attr.aria-label]="convert('common.modalClose')"
          (click)="updatesFromActionBar('')"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
      <ng-container>
        <ng-container>
          <header class="modal__header mb-4">
            <h1 class="modal__title mb-0" tabindex="-1" [ngPlural]="selectedCardCount">
              <ng-template ngPluralCase="one">{{convert('sellModule.posting.photoCard.textWantDeletePhoto')}}</ng-template>
              <ng-template ngPluralCase="other">{{convert('sellModule.posting.photoCard.textWantDeletePhotos')}}</ng-template>
            </h1>
          </header>
          <div class="modal__content">
            <div class="modal__body">
              <div class="modal__actions">
                <button
                  class="btn btn-destructive mb-md-0"
                  data-track-elem="button"
                  data-track-name="Yes, Delete"
                  (click)="closeModalAndEmitAction('delete')"
                  [attr.aria-label]="convert('sellModule.posting.photoCard.ariaLabelYesDelete') + pluralizedPhotoText"
                  [ngPlural]="selectedCardCount"
                  >
                  <ng-template ngPluralCase="one">{{convert('sellModule.posting.photoCard.textYesDeletePhoto')}}</ng-template>
                  <ng-template ngPluralCase="other">{{convert('sellModule.posting.photoCard.textYesDeletePhotos')}}</ng-template>
                </button>
                <button
                  class="btn btn-link cancel-btn me-md-2"
                  data-track-elem="button"
                  data-track-name="No, Cancel"
                  (click)="updatesFromActionBar('')"
                  [attr.aria-label]="convert('sellModule.posting.photoCard.ariaLabelNoCancel')"
                  >
                  {{convert('sellModule.posting.photoCard.ariaLabelNoCancel')}}
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </app-modal>
  </trap-focus>
</ng-container>
